module.exports = __webpack_public_path__ + "img/cl.150b14a8.svg";